<template>
    <img :src="url" v-bind="$attrs" :loading="true" :isReady="isReady" @load="handleLoad" />
</template>
<script>
export default {
    data(){
        return {
            isReady: false
        };
    },
    props:{
        src:{
            type: String,
            default: ''
        }
    },
    computed: {
        url() {
            if( this.src.startsWith('http') || this.src.startsWith('https') ) {
                return this.src;
            }
            return 'https://www.dongri.com' + this.src;
        }
    },
    methods: {
        handleLoad() {
            this.isReady = true;
        }
    },
};
</script>
<style lang="less" scoped>

</style>